<template>
  <svg
    id="icon-arrow"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :fill="fill"
    viewBox="0 0 24 25"
  >
    <path
      d="M21.003 18.439a.739.739 0 0 1-.22.544.7.7 0 0 1-1.015 0 .754.754 0 0 1-.205-.524v-2.482l.106-2.734-1.075 1.208-6.324 6.323a.734.734 0 0 1-.524.226.696.696 0 0 1-.372-.106.799.799 0 0 1-.272-.272.685.685 0 0 1-.106-.365c0-.19.08-.365.239-.524l6.31-6.33 1.208-1.063-2.853.1h-2.362a.73.73 0 0 1-.518-.206.679.679 0 0 1-.219-.504c0-.195.07-.365.212-.511a.725.725 0 0 1 .544-.219h6.663c.239 0 .427.073.564.219a.754.754 0 0 1 .212.557l.007 6.663Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconArrow",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped>
svg {
  padding-right: 10px;
}
</style>
